export default function MainPage() {
  return (
    <>
      <h1>Main page!</h1>
    </>
  )
}
